import { Component } from 'react';
import ShareOfVoice from './components/ShareOfVoice/index.js';
import TopUrls from './components/TopUrls/index.js';
import { getKeywordDataApi } from './query';
import PageHeader from '../../../components/PageHeader/index.js';
import moment from 'moment';
import PagePath from '../../../components/PagePath';
import { AI_TOOLS } from '../configs.js';
import BlockCitation from './components/BlockCitation/index.js';
import GoogleSearchTopUrls from './components/GoogleSearchTopUrls/index.js';
import BlockVisibility from './components/BlockVisibility/index.js';
import { withTranslation } from 'react-i18next';
import { showPlatform } from '../PromptManager/keys.js';
import Filters from '../../Filters/index.js';
import ShowAllItemsModal from '../projects/components/ShowAllItemsModal.js';
import Boxes from './components/Boxes/index.js';
import Brands from './components/Brands/index.js';
import BrandByPlatform from './components/BrandByPlatform/index.js';
import DomainImage from '../../../components/DomainImage/index.js';
import CheckboxDropdown from '../../../components/CheckboxDropdown/index.js';
import Actions from './actions.js';
import UrlPlatformOverlap from './components/UrlPlatformOverlap/index.js';
import CheckboxDropdownFilter from './components/CheckboxDropdownFilter/index.js';
import Prompts from './components/Prompts/index.js';
import Topics from './components/Topics/index.js';
import PromptsPerformingByTag from './components/PromptsPerformingByTag/index.js';
import Responses from './components/Responses/index.js';
import FanoutQueries from './components/FanoutQueries/index.js';
import MessageCustom from '../../../components/MessageCustom/index.js';
import AllLinks from './components/AllLinks/index.js';
import CitationsVsGsc from './components/CitationsVsGsc/index.js';
import { CircleFlag } from 'react-circle-flags';
import Facts from './components/Facts/index.js';
import OnboardingFlow from '../onboarding/OnboardingFlow.js';
import SetupChecklist from '../onboarding/SetupChecklist.js';
import { STEP_BRAND, STEP_PROFILE } from '../onboarding/state.js';

class AiTrackingPrompt extends Component {
    constructor(props) {
        super();
        this.keyword_id = props.id;

        this.url = new URL(window.location);
        this.platforms = this.url.searchParams.get('platforms');
        this.prompts = this.url.searchParams.get('prompts');
        this.tab = this.url.searchParams.get('tab');
        this.tags = this.url.searchParams.get('tags');
        this.countries = this.url.searchParams.get('countries');
        if (this.platforms) this.platforms = this.platforms.split(',');
        if (this.tags) this.tags = this.tags.split(',');
        if (this.countries) this.countries = this.countries.split(',');
        if (this.prompts) {
            this.prompts = this.prompts.split(',').map((item) => Number(item));
            const prompts_uuids =
                props.project?.prompts
                    ?.filter((item) => this.prompts.includes(item.id))
                    ?.map((item) => item.prompt_uid) ?? [];
            this.prompts = prompts_uuids;
        }

        this.createHeader = this.createHeader.bind(this);
        this.updateProject = this.updateProject.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.setOwnValue = this.setOwnValue.bind(this);
        this.onApplyPlatformsSelect = this.onApplyPlatformsSelect.bind(this);
        this.addActive = this.addActive.bind(this);
        this.onChangeTag = this.onChangeTag.bind(this);
        this.onApplyPromptsSelect = this.onApplyPromptsSelect.bind(this);
        this.onApplyTagsSelect = this.onApplyTagsSelect.bind(this);
        this.showCustomHeader = this.showCustomHeader.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
        this.checkDates = this.checkDates.bind(this);
        this.checkChangingDates = this.checkChangingDates.bind(this);
        this.forceRunAll = this.forceRunAll.bind(this);
        this.onApplyCountriesSelect = this.onApplyCountriesSelect.bind(this);
        this.openOnboarding = this.openOnboarding.bind(this);
        this.openSetupStep = this.openSetupStep.bind(this);
        this.openProfileStep = this.openProfileStep.bind(this);
        this.closeOnboarding = this.closeOnboarding.bind(this);

        this.state = {
            data: [],
            loading: false,
            prompt_uids: [],
            selectedPlatforms: this.platforms || [],
            selectedTags: this.tags || [],
            selectedCountries: this.countries || [],
            updatedProject: null,
            showAllKeywords: false,
            isOpenModal: false,
            allData: [],
            ownSentiment: null,
            globalLoading: true,
            tag: this.tab ?? 'overview',
            isEditModalOpen: false,
            // The setup step the flow is open at, or null when it is closed.
            onboardingStep: null,
            updateAll: 0,
            projectCreatedAt: null,
        };
    }

    /**
     * The project the page is reading: the copy an edit left behind if there is one, then the
     * one the project page passes down, or the one the keyword's own data carries.
     */
    currentProject() {
        return (
            this.state.updatedProject ??
            (!this.props.from_project ? this.state.keywordData?.project : this.props.project)
        );
    }

    openEditModal() {
        this.setState({ isEditModalOpen: true });
    }

    closeEditModal() {
        this.setState({ isEditModalOpen: false });
    }

    openOnboarding(step) {
        this.setState({ onboardingStep: step });
    }

    /**
     * The "Setup Now" banner and the checklist's first step both land here.
     *
     * Where it opens depends on what is actually missing rather than on which control was
     * pressed, so neither can drop the user on a step that has nothing left to ask.
     */
    openSetupStep() {
        this.openOnboarding(STEP_BRAND);
    }

    /**
     * "Generate profile here" -- but profiling needs a brand and a domain, and this link is on
     * screen precisely when the project may have neither. Sending it to step 1 in that case is
     * what replaces the modal that used to open with its only button disabled.
     */
    openProfileStep() {
        const project = this.currentProject();
        const needsBrand = !project?.own_domain || !project?.own_product_name;
        this.openOnboarding(needsBrand ? STEP_BRAND : STEP_PROFILE);
    }

    /**
     * Leaving setup, at whatever point it got to.
     *
     * The project page re-reads the project it owns, since a finished step changes more than it
     * reports back; the keyword page has no such call, so it keeps the copy the flow handed over.
     */
    closeOnboarding(project) {
        if (this.props.getProjectData) {
            // A fresh project is on its way down as a prop, and an edited copy kept from
            // earlier would shadow it for good.
            this.setState({ onboardingStep: null, updatedProject: null });
            this.props.getProjectData();
            return;
        }

        this.setState({ onboardingStep: null });
        if (project) this.updateProject(project);
    }

    addActive(value) {
        return this.state.tag === value;
    }

    onOpenModal(data) {
        this.setState({ isOpenModal: true, allData: data });
    }

    onCloseModal() {
        this.setState({ isOpenModal: false, allData: [] });
    }

    checkChangingDates() {
        const project = this.currentProject();

        const firstPromptCreatedDate = (project?.prompts ?? []).reduce((acc, curr) => {
            if (!acc) return curr.created_at;
            if (!curr.created_at) return acc;
            if (moment(acc).isAfter(moment(curr.created_at))) {
                return curr.created_at;
            }
            return acc;
        }, null);

        const projectCreatedAt = firstPromptCreatedDate ?? project?.created_at;
        const end_date_from_filters = window?.filters?.filters?.dates?.values?.end_date?.value;
        const date = moment(end_date_from_filters);
        const end_date = date.add(2, 'days');
        const isFiltersAfterProjectCreationDate = moment(end_date).isBefore(
            moment(projectCreatedAt),
            'day',
        );

        window.firstPromptCreatedDate = firstPromptCreatedDate;
        document.dispatchEvent(new Event('updateProjectCreationDate'));
        this.setState({
            isFiltersAfterProjectCreationDate,
            projectCreatedAt: firstPromptCreatedDate,
        });
    }

    async componentDidMount() {
        document.addEventListener('changeDates', this.checkChangingDates);
        this.checkChangingDates();
        try {
            let k_ids = [];
            let keywordData = null;
            this.setState({ loading: true, globalLoading: true });

            if (this.keyword_id) {
                const oneKeywordRes = await getKeywordDataApi(this.keyword_id);
                keywordData = await oneKeywordRes.json();
                const keyword_uid = keywordData?.prompt_uid;
                k_ids = keyword_uid ? [keyword_uid] : [];
            } else if (this.props.prompt_uids) {
                k_ids = this.props.prompt_uids;
            }

            if (!k_ids || !k_ids?.length) {
                return this.setState({
                    keywordData,
                    prompt_uids: [],
                    globalLoading: false,
                    loading: false,
                });
            }

            const prompt_uids = (this.prompts?.length ? this.prompts : k_ids) ?? [];

            this.setState({
                keywordData,
                prompt_uids,
                globalLoading: false,
            });
        } catch (err) {
            console.log(err);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('changeDates', this.checkChangingDates);
    }

    updateUrlsSearch(tag, values) {
        this.url = new URL(window.location);
        if (values?.length) {
            this.url.searchParams.set(tag, values.join(','));
        } else {
            this.url.searchParams.delete(tag);
        }
        history.pushState({}, '', this.url);
    }

    onApplyPlatformsSelect(values) {
        this.setState({
            selectedPlatforms: values,
        });

        this.updateUrlsSearch('platforms', values);
    }

    onApplyTagsSelect(values) {
        if (values?.length === 0) {
            this.setState({
                selectedTags: values,
                prompt_uids: this.props.project?.prompts.map((item) => item.prompt_uid),
            });
            return;
        }
        const selectedPrompts = this.props.project?.prompts?.filter((item) => {
            const itemTags = item.tags?.map((item) => item.toLowerCase()) ?? [];
            return values.some((value) => itemTags.includes(value.toLowerCase()));
        });

        const selectedPromptUids = selectedPrompts?.map((item) => item.prompt_uid) ?? [];

        this.setState({
            selectedTags: values,
            prompt_uids: selectedPromptUids,
        });

        this.updateUrlsSearch('tags', values);
    }

    onApplyCountriesSelect(values) {
        if (values?.length === 0) {
            this.setState({
                selectedCountries: values,
                prompt_uids: this.props.project?.prompts.map((item) => item.prompt_uid),
            });
            return;
        }
        const selectedPrompts = this.props.project?.prompts?.filter((item) => {
            return values.includes(item.country.toLowerCase());
        });

        const selectedPromptUids = selectedPrompts?.map((item) => item.prompt_uid) ?? [];

        this.setState({
            selectedCountries: values,
            prompt_uids: selectedPromptUids,
        });

        this.updateUrlsSearch('countries', values);
    }

    onApplyPromptsSelect(values, isAllSelected) {
        this.setState({
            prompt_uids: !isAllSelected && values?.length ? values : this.props.prompt_uids,
            selectedTags: [],
            selectedCountries: [],
        });

        this.url = new URL(window.location);
        this.url.searchParams.delete('prompts');

        if (isAllSelected) {
            this.url.searchParams.delete('tags');
        } else {
            const selectedPromptsIds = this.props.project?.prompts
                ?.filter((item) => values.includes(item.prompt_uid))
                ?.map((item) => item.id);
            this.updateUrlsSearch('prompts', selectedPromptsIds);
        }

        history.pushState({}, '', this.url);
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.domain?.toLowerCase().includes(search.toLowerCase()));
    }

    createHeader(keywordData, showKeyword) {
        if (!keywordData) return '';
        const last_run = keywordData.last_crawled
            ? `${moment(keywordData.last_crawled).format('YYYY-MM-DD HH:mm')}`
            : '';

        const platform = !showKeyword
            ? ''
            : this.platforms
            ? this.platforms?.map((item) => (
                  <span className="ai-tracking-header-platform" key={item}>
                      {showPlatform(item)} {item?.replace(/_/g, ' ')}
                  </span>
              ))
            : keywordData?.platforms?.map((item) => (
                  <span className="ai-tracking-header-platform" key={item}>
                      {showPlatform(item)} {AI_TOOLS[item]}
                  </span>
              ));

        return (
            <div className="d-flex align-items-center gap-8">
                {showKeyword && (
                    <span>
                        {keywordData.prompt} {'->'}{' '}
                    </span>
                )}
                {last_run && (
                    <span>
                        {last_run} {'->'}{' '}
                    </span>
                )}
                {platform && <span className="d-flex gap-4 align-items-center">{platform}</span>}
            </div>
        );
    }

    updateProject(project) {
        this.setState({
            updatedProject: project,
        });
        this.forceRunAll();
    }

    setOwnValue(key, value) {
        this.setState({ [key]: value });
    }

    onChangeTag(value) {
        this.setState({
            tag: value,
        });

        this.url = new URL(window.location);
        this.url.searchParams.set('tab', value);
        history.pushState({}, '', this.url);
    }

    showCustomHeader({ selectedOptions, options, defaultLabel, flag }) {
        if (selectedOptions?.length === 0) return defaultLabel;

        const tag =
            flag === 'tags'
                ? 'tags_select_header'
                : flag === 'platforms'
                ? 'platforms_select_header'
                : flag === 'countries'
                ? 'countries_select_header'
                : 'prompts_select_header';

        return this.props.t(`ai_tracking.keyword_detail.${tag}`, {
            selectedNumber: selectedOptions.length,
            totalNumber: options.length,
        });
    }

    checkDates() {
        const project = this.currentProject();

        const projectCreatedAt = project?.created_at;
        const end_date = window?.filters?.filters?.dates?.values?.end_date?.value;

        return moment(projectCreatedAt).isAfter(moment(end_date));
    }

    forceRunAll() {
        this.setState({ updateAll: this.state.updateAll + 1 });
    }

    render() {
        const { t } = this.props;
        const { keywordData } = this.state;
        const totalRuns = this.state.data?.[0]?.totalRuns ?? 1;
        const project = this.currentProject();

        const lastCrawled = project?.prompts?.reduce((acc, curr) => {
            if (!acc) return curr.last_crawled;
            if (!curr.last_crawled) return acc;
            return moment(acc).isAfter(moment(curr.last_crawled)) ? acc : curr.last_crawled;
        }, null);

        const prompts = project?.prompts ?? [];
        const isAllPromptsInactive = prompts?.every((item) => item.status === 'inactive');
        const isPromptsMixed =
            prompts?.length > 0 &&
            !prompts.every((item) => item.frequency === prompts[0].frequency);

        const tags =
            [
                ...new Set(
                    prompts?.flatMap((item) => item.tags)?.map((item) => item.toLowerCase()),
                ),
            ] ?? [];

        const countries =
            [
                ...new Set(
                    prompts?.flatMap((item) => item.country)?.map((item) => item.toLowerCase()),
                ),
            ] ?? [];

        const firstPrompts = prompts?.slice(0, 5);

        const competitors = project?.competitors ?? [];
        const firstCompetitors = competitors?.slice(0, 5);

        const lastRun = this.props.from_project ? lastCrawled : keywordData?.last_crawled;

        const platforms = this.props.from_project ? this.props.platforms : keywordData?.platforms;

        const platformOptions = platforms?.map((item) => ({
            label: AI_TOOLS[item],
            showedValue: (
                <div className="ai-tracking-dropdown-platform">
                    {showPlatform(item)} {AI_TOOLS[item]}
                </div>
            ),
            value: item,
        }));

        const tagsOptions = tags?.map((item) => ({
            label: item,
            value: item,
        }));
        const countriesOptions = countries?.map((item) => ({
            label: item,
            showedValue: (
                <div className="d-flex align-items-center gap-6">
                    <CircleFlag countryCode={item.toLowerCase()} height="22" width="22" />
                    {item}
                </div>
            ),
            value: item,
        }));

        const promptOptions = project?.prompts?.map((item) => ({
            label: item.prompt,
            value: item.prompt_uid,
            status: item.status,
            id: item.id,
            country: item.country,
            language: item.language,
        }));

        const tagsWithPrompts = tags?.map((tag) => {
            const promptsWithTag = project?.prompts
                ?.filter((item) =>
                    item.tags?.map((item) => item.toLowerCase()).includes(tag.toLowerCase()),
                )
                ?.map((item) => item.prompt);
            return {
                tag,
                prompts: promptsWithTag,
            };
        });

        const hasPrompts = !!project?.prompts?.length || !!keywordData?.prompt;
        const hasProfile = !!project?.brand_profile_available;

        const editProjectElement = (
            <div className="d-flex gap-16 align-items-center ai-tracking-prompt-header-project">
                <div className="ai-tracking-prompt-subheader-info">
                    {!this.props.from_project && (
                        <>
                            <div className="ai-tracking-prompt-subheader-info-item">
                                {keywordData?.country}
                                <span>({keywordData?.language})</span>
                            </div>
                            <div className="ai-tracking-prompt-subheader-info-item">
                                {keywordData?.frequency === 'weekly' ? (
                                    <img
                                        title={t(
                                            'ai_tracking.add_keyword.frequency_options.weekly',
                                        )}
                                        className="frequency-img"
                                        src="/static/img/weekly.svg"
                                    />
                                ) : (
                                    <img
                                        title={t('ai_tracking.add_keyword.frequency_options.daily')}
                                        className="frequency-img"
                                        src="/static/img/daily.svg"
                                    />
                                )}
                                {keywordData?.frequency}
                            </div>
                        </>
                    )}
                    {lastRun && (
                        <div className="ai-tracking-prompt-subheader-info-item">
                            <span>{t('ai_tracking.global.last_run')}</span>
                            {lastRun ? moment(lastRun).format('YYYY-MM-DD HH:mm') : '-'}
                        </div>
                    )}
                    <div className="ai-tracking-prompt-subheader-info-item">
                        <div className="ai-tracking-prompt-subheader-info-item-domain">
                            <DomainImage domain_name={project?.own_domain} size="20" />

                            <div>{project?.own_product_name}</div>
                            <span>{project?.own_domain}</span>
                        </div>
                    </div>
                </div>
                <Actions
                    showAll
                    project={project}
                    updateProject={this.updateProject}
                    openEditModal={this.openEditModal}
                    closeEditModal={this.closeEditModal}
                    forceRunAll={this.forceRunAll}
                    isEditModalOpen={this.state.isEditModalOpen}
                />
            </div>
        );

        const tabs = (t) => [
            { id: 'overview', label: t('ai_tracking.keyword_detail.tabs.overview') },
            { id: 'citations', label: t('ai_tracking.keyword_detail.tabs.citation') },
            { id: 'mentions', label: t('ai_tracking.keyword_detail.tabs.mentions') },
            { id: 'classic_search', label: t('ai_tracking.keyword_detail.tabs.classic_search') },
            { id: 'prompts', label: t('ai_tracking.keyword_detail.tabs.prompts') },
            { id: 'answers', label: t('ai_tracking.keyword_detail.tabs.answers') },
            {
                id: 'fanout_queries',
                label: t('ai_tracking.keyword_detail.fanoutQueries.header'),
            },
            { id: 'all_links', label: t('ai_tracking.keyword_detail.tabs.all_links') },
            {
                id: 'citations_vs_gsc',
                label: t('ai_tracking.keyword_detail.tabs.citations_vs_gsc'),
            },
            { id: 'topics', label: t('ai_tracking.keyword_detail.tabs.topics') },
            { id: 'facts', label: t('ai_tracking.keyword_detail.tabs.facts') },
        ];

        const isProjectCreatedDateAfterFilters =
            this.state.isFiltersAfterProjectCreationDate && project?.prompts?.length > 0;

        return (
            <>
                {(this.props.from_project || keywordData?.prompt) && (
                    <PagePath
                        paths={
                            this.props.from_project
                                ? `ai_tracking.header,layout.menuItems.keyword_manager,${
                                      this.props.project?.name ?? ''
                                  }  `
                                : `ai_tracking.header,ai_tracking.keyword_detail.header,${
                                      keywordData?.prompt ?? ''
                                  }`
                        }
                        has_domain="true"
                        links="/ai-tracking/,/ai-tracking/"
                    />
                )}
                {(!project?.own_domain || !project?.own_product_name) && (
                    <div className="my-10">
                        <MessageCustom
                            message={t('ai_tracking.keyword_detail.messages.setup_required')}
                            message_type={'alert-warning'}
                            hasButton
                            buttonName={t('ai_tracking.keyword_detail.messages.setup_now')}
                            onButtonClick={this.openSetupStep}
                        />
                    </div>
                )}
                {this.props.from_project && (
                    <SetupChecklist project={project} onOpenStep={this.openOnboarding} />
                )}
                {!!prompts?.length && isAllPromptsInactive && (
                    <div className="my-10">
                        <MessageCustom
                            message={t('ai_tracking.keyword_detail.messages.all_prompts_inactive')}
                            message_type={'alert-warning'}
                        />
                    </div>
                )}
                {!isAllPromptsInactive && isPromptsMixed && (
                    <div className="my-10">
                        <MessageCustom
                            message={t('ai_tracking.keyword_detail.messages.mixed_frequencies')}
                            message_type={'alert-warning'}
                        />
                    </div>
                )}
                {isProjectCreatedDateAfterFilters && (
                    <div className="my-10">
                        <MessageCustom
                            message={t(
                                'ai_tracking.keyword_detail.messages.date_range_before_project',
                                {
                                    date: moment(this.state.projectCreatedAt).format('MM/DD/YYYY'),
                                },
                            )}
                            message_type={'alert-warning'}
                        />
                    </div>
                )}
                <div className="ai-tracking-prompt-header">
                    {(keywordData?.prompt || this.props.from_project) && (
                        <div className="d-flex align-items-center justify-content-between">
                            <PageHeader
                                header={
                                    this.props.from_project
                                        ? `"${this.props.project?.name ?? ''}"`
                                        : `"${keywordData?.prompt ?? ''}"`
                                }
                                hide_filters
                                additionalItem={editProjectElement}
                            />
                        </div>
                    )}
                    {hasPrompts &&
                        hasProfile &&
                        (this.props.from_project || keywordData?.prompt) && (
                            <div className="ai-tracking-prompt-subheader mt-10">
                                {this.props.from_project && (
                                    <>
                                        <div
                                            className="ai-tracking-platform-dropdown"
                                            style={{
                                                display:
                                                    this.state.tag !== 'answers' ? 'block' : 'none',
                                            }}
                                        >
                                            <CheckboxDropdownFilter
                                                options={promptOptions}
                                                label={t('ai_tracking.global.select_prompts')}
                                                alreadySelected={this.prompts || []}
                                                onApply={this.onApplyPromptsSelect}
                                                brand={project?.own_product_name}
                                                selectedTags={this.state.selectedTags}
                                                values={this.state.prompt_uids}
                                            />
                                        </div>
                                        <div
                                            className="ai-tracking-platform-dropdown"
                                            style={{
                                                display:
                                                    this.state.tag !== 'answers' ? 'block' : 'none',
                                            }}
                                        >
                                            <CheckboxDropdown
                                                options={tagsOptions}
                                                label={t('ai_tracking.global.select_tags')}
                                                alreadySelected={this.tags || []}
                                                onApply={this.onApplyTagsSelect}
                                                values={this.state.selectedTags}
                                                hasSearch
                                                showCustomHeader={this.showCustomHeader}
                                                flag="tags"
                                            />
                                        </div>
                                        <div
                                            className="ai-tracking-platform-dropdown"
                                            style={{
                                                display:
                                                    this.state.tag !== 'answers' ? 'block' : 'none',
                                            }}
                                        >
                                            <CheckboxDropdown
                                                options={countriesOptions}
                                                label={t('ai_tracking.global.select_countries')}
                                                alreadySelected={this.countries || []}
                                                onApply={this.onApplyCountriesSelect}
                                                values={this.state.selectedCountries}
                                                hasSearch
                                                showCustomHeader={this.showCustomHeader}
                                                flag="countries"
                                            />
                                        </div>
                                    </>
                                )}
                                <div
                                    className="ai-tracking-platform-dropdown"
                                    style={{
                                        display: this.state.tag !== 'answers' ? 'block' : 'none',
                                    }}
                                >
                                    <CheckboxDropdown
                                        options={platformOptions}
                                        label={t('ai_tracking.global.select_platforms')}
                                        alreadySelected={this.platforms || []}
                                        onApply={this.onApplyPlatformsSelect}
                                        showCustomHeader={this.showCustomHeader}
                                        flag="platforms"
                                    />
                                </div>

                                <div className="d-flex gap-10 align-items-center">
                                    <Filters
                                        gsc_report={this.props.gsc_report}
                                        select_by_week={this.props.select_by_week}
                                    />
                                </div>
                            </div>
                        )}
                </div>
                {hasPrompts && hasProfile && this.props.from_project && (
                    <>
                        <div className="card table-main rounded-main overflow-hidden p-0 mb-16">
                            <div className="ai-tracking-project-info">
                                <div className="ai-tracking-project-info-header">
                                    <div className="w-50">
                                        {t('ai_tracking.keyword_detail.label_prompts')}
                                    </div>
                                    <div className="w-50">
                                        {t('ai_tracking.keyword_detail.competitors')}
                                    </div>
                                </div>
                                <div className="ai-tracking-project-info-body">
                                    <div className="w-50 ai-tracking-prompts-items">
                                        {firstPrompts?.map((item, i) => (
                                            <div
                                                key={i}
                                                className={`ai-tracking-project-keywords ${
                                                    item.status === 'inactive' ? 'inactive' : ''
                                                }`}
                                            >
                                                {item.prompt}
                                            </div>
                                        ))}
                                        {project?.prompts?.length > firstPrompts?.length && (
                                            <div
                                                className="ai-tracking-platform-show-more"
                                                onClick={() =>
                                                    this.onOpenModal(
                                                        project?.prompts?.map((item) => ({
                                                            item: item.prompt,
                                                            status: item.status,
                                                        })),
                                                    )
                                                }
                                            >
                                                +{project?.prompts?.length - firstPrompts?.length}
                                            </div>
                                        )}
                                    </div>
                                    <div className="w-50 ai-tracking-prompts-items">
                                        {firstCompetitors?.map((item, i) => (
                                            <div key={i} className="ai-tracking-project-keywords">
                                                <DomainImage
                                                    domain_name={item.domain}
                                                    className="domain_img"
                                                />{' '}
                                                {item.domain}
                                            </div>
                                        ))}
                                        {project?.competitors?.length >
                                            firstCompetitors?.length && (
                                            <div
                                                className="ai-tracking-platform-show-more"
                                                onClick={() =>
                                                    this.onOpenModal(
                                                        project?.competitors?.map((item) => ({
                                                            item: item.domain,
                                                        })),
                                                    )
                                                }
                                            >
                                                +
                                                {project?.competitors?.length -
                                                    firstCompetitors?.length}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {hasPrompts && hasProfile && (
                    <>
                        {this.props.from_project && (
                            <Boxes
                                citiationShare={this.state.citiationShare}
                                ownSentiment={this.state.ownSentiment}
                                ownRank={this.state.ownRank}
                                ownAvgPosition={this.state.ownAvgPosition}
                                ownBrandMentions={this.state.ownBrandMentions}
                            />
                        )}
                        <div className="main tags-container">
                            {tabs(t).map((tab) => (
                                <span
                                    className={`tab-item ${this.addActive(tab.id) && 'active-tag'}`}
                                    key={tab.id}
                                    onClick={() => this.onChangeTag(tab.id)}
                                >
                                    {tab.label}
                                </span>
                            ))}
                        </div>
                        <div style={{ display: this.state.tag === 'overview' ? 'block' : 'none' }}>
                            <BlockCitation
                                prompt_uids={this.state.prompt_uids}
                                totalRuns={totalRuns}
                                project={project}
                                updateProject={this.updateProject}
                                platforms={this.state.selectedPlatforms}
                                globalLoading={this.state.globalLoading}
                                updateAll={this.state.updateAll}
                            />
                            <UrlPlatformOverlap
                                prompt_uids={this.state.prompt_uids}
                                globalLoading={this.state.globalLoading}
                                updateAll={this.state.updateAll}
                            />
                            <PromptsPerformingByTag
                                prompt_uids={this.state.prompt_uids}
                                project={project}
                                tagsWithPrompts={tagsWithPrompts}
                                updateAll={this.state.updateAll}
                                moveToPrompts={() => this.onChangeTag('prompts')}
                            />
                        </div>
                        <div style={{ display: this.state.tag === 'citations' ? 'block' : 'none' }}>
                            {!!project && (
                                <BlockVisibility
                                    prompt_uids={this.state.prompt_uids}
                                    totalRuns={totalRuns}
                                    project={project}
                                    updateProject={this.updateProject}
                                    platforms={this.state.selectedPlatforms}
                                    globalLoading={this.state.globalLoading}
                                    updateAll={this.state.updateAll}
                                />
                            )}
                            <ShareOfVoice
                                loading={this.state.loading}
                                prompt_uids={this.state.prompt_uids}
                                platforms={this.state.selectedPlatforms}
                                data={this.state.data}
                                project={project}
                                updateProject={this.updateProject}
                                citiationShare={this.state.citiationShare}
                                setOwnValue={(value) => this.setOwnValue('citiationShare', value)}
                                updateAll={this.state.updateAll}
                            />
                            <TopUrls
                                loading={this.state.loading}
                                data={this.state.data}
                                prompt_uids={this.state.prompt_uids}
                                project={project}
                                platforms={this.state.selectedPlatforms}
                                setOwnValue={(value) => this.setOwnValue('ownAvgPosition', value)}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div style={{ display: this.state.tag === 'all_links' ? 'block' : 'none' }}>
                            <AllLinks
                                loading={this.state.loading}
                                data={this.state.data}
                                prompt_uids={this.state.prompt_uids}
                                project={project}
                                platforms={this.state.selectedPlatforms}
                                setOwnValue={(value) => this.setOwnValue('ownAvgPosition', value)}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div style={{ display: this.state.tag === 'mentions' ? 'block' : 'none' }}>
                            <Brands
                                prompt_uids={this.state.prompt_uids}
                                totalRuns={totalRuns}
                                project={project}
                                updateProject={this.updateProject}
                                setOwnValue={this.setOwnValue}
                                platforms={this.state.selectedPlatforms}
                                globalLoading={this.state.globalLoading}
                                updateAll={this.state.updateAll}
                            />
                            <BrandByPlatform
                                prompt_uids={this.state.prompt_uids}
                                platforms={this.state.selectedPlatforms}
                                globalLoading={this.state.globalLoading}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div
                            style={{
                                display: this.state.tag === 'classic_search' ? 'block' : 'none',
                            }}
                        >
                            <GoogleSearchTopUrls
                                prompt_uids={this.state.prompt_uids}
                                totalRuns={totalRuns}
                                project={project}
                                updateProject={this.updateProject}
                                setOwnValue={(value) => this.setOwnValue('ownRank', value)}
                                platforms={this.state.selectedPlatforms}
                                globalLoading={this.state.globalLoading}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div
                            style={{
                                display: this.state.tag === 'citations_vs_gsc' ? 'block' : 'none',
                            }}
                        >
                            <CitationsVsGsc
                                prompt_uids={this.state.prompt_uids}
                                project={project}
                                platforms={this.state.selectedPlatforms}
                                updateProject={this.updateProject}
                                globalLoading={this.state.globalLoading}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div style={{ display: this.state.tag === 'prompts' ? 'block' : 'none' }}>
                            <Prompts
                                prompt_uids={this.state.prompt_uids}
                                project={project}
                                getProjectData={this.props.getProjectData}
                                loadingProjectForChildren={this.props.loadingProjectForChildren}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div style={{ display: this.state.tag === 'topics' ? 'block' : 'none' }}>
                            <Topics
                                project={project}
                                getProjectData={this.props.getProjectData}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div style={{ display: this.state.tag === 'facts' ? 'block' : 'none' }}>
                            <Facts
                                prompt_uids={this.state.prompt_uids}
                                project={project}
                                platforms={this.state.selectedPlatforms}
                                getProjectData={this.props.getProjectData}
                                loadingProjectForChildren={this.props.loadingProjectForChildren}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div
                            style={{
                                display: this.state.tag === 'fanout_queries' ? 'block' : 'none',
                            }}
                        >
                            <FanoutQueries
                                prompt_uids={this.state.prompt_uids}
                                project={project}
                                platforms={this.state.selectedPlatforms}
                                getProjectData={this.props.getProjectData}
                                loadingProjectForChildren={this.props.loadingProjectForChildren}
                                updateAll={this.state.updateAll}
                            />
                        </div>
                        <div style={{ display: this.state.tag === 'answers' ? 'block' : 'none' }}>
                            <Responses prompt_uids={this.state.prompt_uids} project={project} />
                        </div>

                        {this.state.isOpenModal && (
                            <ShowAllItemsModal
                                isOpen={this.state.isOpenModal}
                                onClose={this.onCloseModal}
                                data={this.state.allData?.map((item) => ({
                                    name: item.item,
                                    status: item.status,
                                }))}
                                placeholder={t('ai_tracking.global.search')}
                            />
                        )}
                    </>
                )}
                {hasProfile && !hasPrompts && (
                    <div className="no-prompts">
                        {t('ai_tracking.keyword_detail.no_prompts.text')}
                        <a href={`/ai-tracking/prompt-generator/?projectId=${project?.id}`}>
                            {t('ai_tracking.keyword_detail.no_prompts.link')}
                        </a>
                    </div>
                )}
                {!hasProfile && (
                    <div className="no-prompts">
                        {t('ai_tracking.keyword_detail.no_profile.text')}
                        <button type="button" onClick={this.openProfileStep}>
                            {t('ai_tracking.keyword_detail.no_profile.link')}
                        </button>
                    </div>
                )}
                {this.state.onboardingStep !== null && (
                    <OnboardingFlow
                        project={project}
                        initialStep={this.state.onboardingStep}
                        onProjectChanged={this.updateProject}
                        onClose={this.closeOnboarding}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(AiTrackingPrompt);
